const MOBILE_REACH_END_MESSAGE_THRESHOLD = 3
const DESKTOP_REACH_END_MESSAGE_THRESHOLD = 15

export {
  MOBILE_REACH_END_MESSAGE_THRESHOLD,
  DESKTOP_REACH_END_MESSAGE_THRESHOLD
}
